/* unplugin-vue-components disabled */import { render } from "./StudentEnrolmentTable.vue?vue&type=template&id=94eeb07a&scoped=true"
import script from "./StudentEnrolmentTable.vue?vue&type=script&lang=js"
export * from "./StudentEnrolmentTable.vue?vue&type=script&lang=js"

import "./StudentEnrolmentTable.vue?vue&type=style&index=0&id=94eeb07a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94eeb07a"]])

export default __exports__